// A flyer or source image, whole (never cropped, so a flyer's text stays readable), letterboxed on a blurred copy of
// itself (web/sheets.js flyer). Gone if it fails to load.
import { useState, type CSSProperties } from "react";
import styles from "./Flyer.module.css";

export function Flyer({ src, className, id, lazy = false }: { src: string; className?: string; id?: string; lazy?: boolean }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <div id={id} className={className ? `${styles.flyer} ${className}` : styles.flyer} style={{ "--img": `url("${src.replace(/"/g, "%22")}")` } as CSSProperties}>
      <img src={src} alt="" loading={lazy ? "lazy" : undefined} onError={() => setFailed(true)} />
    </div>
  );
}
